import React from 'react';
import {
    Menu, Dropdown,
    Slider, InputNumber, Row, Col
    
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
const { SubMenu } = Menu;



export class RigControl extends React.Component {
    /**
     * This is the class which peeps gonna use to control rig euuu
     */
    constructor(props) {
        super(props);


        this.state = {
            inputValue: 1
        }


    }
    
      onChange = value => {
        this.setState({
          inputValue: value,
        });
      };

    render() {
        const menu = (<Menu>
            <Menu.Item>
                <Row>Opacity</Row>
                <Row>
                <Slider
                style={{
                    width:'400px',
                    height:'500px'
                }}
                    min={0}
                    max={1}
                    step={0.01}
                    // onChange={this.onChange}
                    // value={typeof inputValue === 'number' ? inputValue : 0}
                />
                </Row>
                <div
                
                ></div>
            </Menu.Item>
        </Menu>)


        return (
            <Dropdown overlay={menu}

            >
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                Rig Controls <DownOutlined />
                </a>
            </Dropdown>
        );
    }
};